import React           from 'react';
import PropTypes       from 'prop-types'
import ArrayRailsSides from './ArrayRailsSides';
import ArrayRailsWidth from './ArrayRailsWidth';
import ErrorLabel     from './base/ErrorLabel';

const ArrayRailsSidesWidth = props => (
  <div className="row">
    <div className="col-md-6">
      <ArrayRailsSides {...props} />
    </div>
    <div className="col-md-6">
      <ArrayRailsWidth {...props} />
    </div>
  </div>
);

ArrayRailsSidesWidth.defaultProps = {
  label   : 'Rail Width',
  required: false,
  tooltip : 'All rails have a width of 0.5 inches.',
};

ArrayRailsSidesWidth.propTypes = {
}

export default ArrayRailsSidesWidth;
